import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function DiscountList() {
    const [discounts, setDiscounts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchOverview = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/discount-codes/overview`,
                    { withCredentials: true }
                );
                setDiscounts(response.data || []);
            } catch (err) {
                setError('Kunne ikke laste rabattoversikt');
            }
        };
        fetchOverview();
    }, []);

    const filteredDiscounts = useMemo(() => {
        const needle = searchTerm.trim().toLowerCase();
        if (!needle) return discounts;
        return discounts.filter((discount) => {
            const matchesCode = discount.code?.toLowerCase().includes(needle);
            if (matchesCode) return true;
            return (discount.registered_users || []).some((user) => (
                user.name?.toLowerCase().includes(needle) ||
                user.email?.toLowerCase().includes(needle) ||
                user.phone_number?.toLowerCase().includes(needle)
            ));
        });
    }, [discounts, searchTerm]);

    return (
        <div className="page-container">
            <div className="page-header-stack">
                <Link to="/dashboard" className="back-button">
                    <i className="fas fa-arrow-left"></i> Tilbake til hovedsiden
                </Link>
                <h1>Rabattoversikt</h1>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="search-container">
                <div className="search-filter">
                    <label htmlFor="discountSearch">
                        <i className="fas fa-search"></i> Søk:
                    </label>
                    <input
                        id="discountSearch"
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Kode, navn, e-post eller telefon"
                        className="search-input"
                    />
                </div>
            </div>

            <div className="list-container">
                {filteredDiscounts.map((discount) => (
                    <div key={discount.iddiscount_code} className="list-item">
                        <div className="discount-info">
                            <h3>{discount.code}</h3>
                            <p><strong>{discount.percentage}%</strong> rabatt</p>
                            <p>Registrert med kode: {discount.registered_users_count || 0}</p>
                            <p>Har abonnement: {discount.registered_users_with_subscription_count || 0}</p>
                            <p>Total brukt (checkout): {discount.used_count || 0}</p>
                            {discount.valid_until && (
                                <p>
                                    Gyldig til:{' '}
                                    {new Date(discount.valid_until).toLocaleString('nb-NO', {
                                        timeZone: 'Europe/Oslo',
                                        dateStyle: 'short',
                                        timeStyle: 'short',
                                    })}
                                </p>
                            )}
                        </div>

                        <div style={{ marginTop: '0.75rem' }}>
                            <h4 style={{ marginBottom: '0.5rem' }}>Brukere som registrerte seg med koden</h4>
                            {Array.isArray(discount.registered_users) && discount.registered_users.length > 0 ? (
                                <ul style={{ margin: 0, paddingLeft: '1.1rem' }}>
                                    {discount.registered_users.map((user) => (
                                        <li key={`${discount.code}-${user.idusers}`} style={{ marginBottom: '0.35rem' }}>
                                            <strong>{user.name || 'Ukjent navn'}</strong> ({user.email || 'Ingen e-post'})
                                            {user.phone_number ? ` - ${user.phone_number}` : ''}
                                            {user.has_subscription ? ' - abonnement aktivert' : ' - ingen abonnement enda'}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>Ingen brukere registrert med denne koden ennå.</p>
                            )}
                        </div>
                    </div>
                ))}
                {filteredDiscounts.length === 0 && (
                    <p>Fant ingen rabattkoder som matcher søket.</p>
                )}
            </div>
        </div>
    );
}
